import gfm from 'remark-gfm'
import ReactMarkdown from 'react-markdown'
import { Panel } from 'rsuite'
import markdown from '../data/changelog.md'
import CenterLayout from '../components/shared/CenterLayout'
import Container from '../components/shared/Container'

const Changelog = (): JSX.Element => {
  return (
    <CenterLayout>
      <Container maxWidth={900} className="space-y-8">
        <Panel bodyFill shaded className="bg-white">
          <div className="p-8">
            <ReactMarkdown remarkPlugins={[gfm]} className="markdown">
              {markdown}
            </ReactMarkdown>
          </div>
        </Panel>
      </Container>
    </CenterLayout>
  )
}

Changelog.auth = false

export default Changelog
